// Custom JavaScript for Pilgrim Theme
// Handles cart-triggered customer data refresh

$(document).ready(function() {
    console.log('🛒 Custom.js loaded');
    
    // Initialize cart data refresh monitoring
    initializeCartDataRefresh();
});
  
// Function to check if customer data refresh is needed when cart is accessed
// OPTIMIZED: Only triggers on actual cart viewing (Method 1 & 4) to minimize API calls
// Customer addresses don't change frequently during shopping session
function initializeCartDataRefresh() {
     console.log('🛒 [DEBUG] Initializing OPTIMIZED cart data refresh monitoring...');
     console.log('🛒 [DEBUG] Only triggers on: Cart icon clicks, Cart page visits, Cart open events');
    
    // Key to track if we've already refreshed data this session
    const SESSION_REFRESH_KEY = 'pilgrim_cart_data_refreshed_session';
    
       // Check if we already refreshed this session
     let sessionRefreshed = sessionStorage.getItem(SESSION_REFRESH_KEY);
     
     // Prevent multiple simultaneous executions
     let isCurrentlyRefreshing = false;
     let lastRefreshAttempt = 0;
     const COOLDOWN_PERIOD = 5000; // 5 seconds cooldown between attempts
    
             // Function to refresh customer data and update cart attributes
     function refreshCustomerDataOnce() {
       const refreshStartTime = Date.now();
       console.log('🛒 [REFRESH] === Starting cart data refresh process ===');
       
       // Check if already refreshed this session
       if (sessionRefreshed) {
         console.log('🛒 [REFRESH] ⏭️ Customer data already refreshed this session, skipping...');
         console.log('🛒 [REFRESH] ℹ️ Cart attributes should already be available for checkout');
         return;
       }
       
       // Check cooldown period to prevent rapid successive calls
       if (refreshStartTime - lastRefreshAttempt < COOLDOWN_PERIOD) {
         console.log(`🛒 [REFRESH] ⏱️ Cooldown active, skipping (${COOLDOWN_PERIOD - (refreshStartTime - lastRefreshAttempt)}ms remaining)`);
         return;
       }
       
       // Check if currently refreshing to prevent loops
       if (isCurrentlyRefreshing) {
         console.log('🛒 [REFRESH] ⏳ Refresh already in progress, skipping...');
         return;
       }
       
       lastRefreshAttempt = refreshStartTime;
       
       // Check if user is logged in via JWT
       if (!PilgrimAuth || !PilgrimAuth.isLoggedIn()) {
         console.log('🛒 [REFRESH] ❌ User not logged in, skipping cart data refresh');
         return;
       }
       
       // Set flag to prevent multiple executions
       isCurrentlyRefreshing = true;
       
       console.log('🛒 [REFRESH] ✅ User is logged in, refreshing customer data for cart session...');
       console.log('🛒 [REFRESH] ⏱️ Refresh started at:', new Date().toISOString());
       
       // Call the customer data API to get fresh data
       PilgrimAuth.getCustomerData()
         .then(response => {
           if (response && response.data && response.data.customer) {
             const debugData = {
               timestamp: new Date().toISOString(),
               customerId: PilgrimAuth.getCurrentCustomerId(),
               customer: response.data.customer,
               orders: response.data.orders
             };
             
             emitPgTracking(PilgrimAuth.getCurrentCustomerId().split("/").pop());
             
             localStorage.setItem('pilgrim_debug_customer_data', JSON.stringify(debugData));
             sessionStorage.setItem(SESSION_REFRESH_KEY, 'true');
             sessionRefreshed = 'true'; // Update local variable
             
             const dataRefreshDuration = Date.now() - refreshStartTime;
             console.log(`✅ [REFRESH] Customer data refreshed in ${dataRefreshDuration}ms`);
             console.log('✅ [REFRESH] Address count:', response.data.customer.addresses?.length || 0);
             
                       // Update cart attributes with address data (run in background)
            console.log('🛒 [REFRESH] ⏱️ Scheduling cart attributes update in 100ms...');
            setTimeout(() => {
              console.log('🛒 [REFRESH] 🚀 Starting cart attributes update now...');
              updateCartAttributesWithAddresses(response.data.customer.addresses);
              
              // Reset flag after completion
              isCurrentlyRefreshing = false;
            }, 100); // Fast delay for immediate checkout readiness
           }
         })
         .catch(error => {
           const errorDuration = Date.now() - refreshStartTime;
          //  console.error(`❌ [REFRESH] Failed to refresh customer data after ${errorDuration}ms:`, error);
          //  console.error('❌ [REFRESH] Error details:', error.message);
           
           // Reset flag on error
           isCurrentlyRefreshing = false;
         });
     }
    
       // Monitor cart drawer/page access
     // Method 1: Monitor cart drawer open events - target specific cart elements
     $(document).on('click', '[href*="/cart"], [aria-controls="mini-cart"], .cart-drawer-trigger, .cart-icon, .cart-link, .cart-toggle, .header__icon-wrapper[aria-label*="Cart"]', function(e) {
       const clickedElement = $(this);
       const href = clickedElement.attr('href') || '';
       const ariaControls = clickedElement.attr('aria-controls') || '';
       const ariaLabel = clickedElement.attr('aria-label') || '';
       
       console.log('🛒 [DEBUG] Element clicked:', {
         tagName: clickedElement[0].tagName,
         href: href,
         ariaControls: ariaControls,
         ariaLabel: ariaLabel,
         classes: clickedElement.attr('class')
       });
       
       // Only trigger for actual cart links/buttons
       if (href.includes('/cart') || 
           ariaControls.includes('cart') || 
           ariaLabel.toLowerCase().includes('cart') ||
           clickedElement.hasClass('cart-icon') || 
           clickedElement.hasClass('cart-toggle')) {
         console.log('🛒 [DEBUG] ✅ Cart access detected via click - triggering refresh');
         setTimeout(refreshCustomerDataOnce, 800); // 800ms delay to not hinder cart opening
       } else {
         console.log('🛒 [DEBUG] ❌ Non-cart click detected, ignoring');
       }
     });
    
       // Method 2: Monitor URL changes for cart page
     if (window.location.pathname === '/cart') {
       console.log('🛒 [DEBUG] Cart page detected on load');
       setTimeout(refreshCustomerDataOnce, 500); // Delay to ensure all scripts are loaded
     }
     
     // Method 2.5: Add to Cart monitoring - DISABLED to minimize API calls
     // Customer addresses don't change frequently during shopping session
     // Only trigger on actual cart viewing for optimal performance
    
    // Method 3: Monitor dynamic cart drawer appearances (using MutationObserver)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if cart drawer or cart-related element was added
            if (node.classList && (
              node.classList.contains('cart-drawer') ||
              node.classList.contains('cart-popup') ||
              node.classList.contains('cart-modal') ||
              node.id === 'cart-drawer' ||
              node.id === 'mini-cart'
                       )) {
               console.log('🛒 [DEBUG] Cart drawer/popup detected via DOM mutation');
               setTimeout(refreshCustomerDataOnce, 800);
             }
          }
        });
      });
    });
    
    // Start observing DOM changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
         // Method 4: Monitor specific Shopify cart events (if available)
    document.addEventListener('cart:open', function() {
      console.log('🛒 [DEBUG] Cart opened via Shopify event');
      setTimeout(refreshCustomerDataOnce, 800);
    });
    
    // Method 5: Listen for login success to immediately refresh cart data
    document.addEventListener('pilgrimLoginSuccess', function(event) {
      console.log('🛒 [DEBUG] Login success detected - triggering immediate cart refresh for checkout');
      console.log('🛒 [DEBUG] Customer ID from login event:', event.detail?.customerId);
      
      // Reset session flag to allow immediate refresh after login
      sessionStorage.removeItem(SESSION_REFRESH_KEY);
      sessionRefreshed = null;
      
      // Trigger immediate cart refresh after login
      setTimeout(() => {
        console.log('🛒 [DEBUG] Executing post-login cart refresh...');
        refreshCustomerDataOnce();
      }, 200); // Fast delay for immediate checkout readiness
    });
    
    // Cart events monitoring - DISABLED to minimize API calls
    // Only trigger on actual cart viewing for optimal performance
   
      // Method 6: Cart API monitoring - DISABLED to minimize API calls
    // Customer addresses don't change frequently during shopping session
    // Only trigger on actual cart viewing for optimal performance
   
      console.log('✅ [DEBUG] Cart data refresh monitoring initialized');
}

// Function to update cart attributes with address data for checkout extension
function updateCartAttributesWithAddresses(addresses) {
     console.log('🛒 [CART-ATTRS] Starting cart attributes update...');
     console.log('🛒 [CART-ATTRS] Received addresses count:', addresses?.length || 0);
     
     if (!addresses || !Array.isArray(addresses) || addresses.length === 0) {
       console.log('🛒 [CART-ATTRS] ❌ No addresses to update in cart attributes');
       return;
     }
     
          try {
         // Format addresses for checkout extension
         console.log('🛒 [CART-ATTRS] Formatting addresses for checkout extension...');
         const formattedAddresses = addresses.map((addr, index) => {
           console.log(`🛒 [CART-ATTRS] Processing address ${index + 1}:`, {
             firstName: addr.firstName,
             lastName: addr.lastName,
             city: addr.city,
             province: addr.province || addr.provinceCode
           });
           return {
             firstName: addr.firstName || '',
             lastName: addr.lastName || '',
             address1: addr.address1 || '',
             address2: addr.address2 || '',
             city: addr.city || '',
             provinceCode: addr.province || addr.provinceCode || '',
             countryCode: addr.country || addr.countryCode || 'IN',
             zip: addr.zip || '',
             phone: addr.phone || ''
           };
         });
         
         const addressData = { addresses: formattedAddresses };
         const jsonString = JSON.stringify(addressData);
         
         console.log('🛒 [CART-ATTRS] Address data JSON length:', jsonString.length);
         console.log('🛒 [CART-ATTRS] Address data preview:', jsonString.substring(0, 200) + '...');
       
              // Chunk the JSON string to fit cart attribute limits
         const ATTR_PREFIX = 'pdc_addr_';
         const ATTR_LEN = 'pdc_addr_len';
         const CHUNK_SIZE = 250; // Safe chunk size for cart attributes
         
         console.log('🛒 [CART-ATTRS] Starting chunking process...');
         console.log('🛒 [CART-ATTRS] Chunk size:', CHUNK_SIZE);
         
         const chunks = [];
         for (let i = 0; i < jsonString.length; i += CHUNK_SIZE) {
           const chunk = jsonString.substring(i, i + CHUNK_SIZE);
           chunks.push(chunk);
           console.log(`🛒 [CART-ATTRS] Chunk ${chunks.length}: length ${chunk.length}`);
         }
         
         console.log('🛒 [CART-ATTRS] ✅ Created', chunks.length, 'chunks for cart attributes');
       
              // Prepare cart attributes
         console.log('🛒 [CART-ATTRS] Preparing cart attributes object...');
         const cartAttributes = {};
         cartAttributes[ATTR_LEN] = chunks.length.toString();
         
         chunks.forEach((chunk, index) => {
           const attrKey = `${ATTR_PREFIX}${index}`;
           cartAttributes[attrKey] = chunk;
           console.log(`🛒 [CART-ATTRS] Attribute ${attrKey}: "${chunk.substring(0, 50)}..."`);
         });
         
         console.log('🛒 [CART-ATTRS] ✅ Cart attributes prepared:', Object.keys(cartAttributes));
         console.log('🛒 [CART-ATTRS] Total attributes count:', Object.keys(cartAttributes).length);
       
       // Update cart attributes via Shopify Cart API
       updateCartAttributes(cartAttributes);
       
          } catch (error) {
            // console.error("CAA: Error updating cart attributes with addresses:", error);
            // try {
            //   newrelic.log('CAA NR: Error updating cart attributes with addresses:', {level: 'error', customAttributes: { errMessage: error?.message, errStack: error?.stack, kind: error?.name }})
            // } catch(e) {}
         console.warn('❌ [CART-ATTRS] Error updating cart attributes with addresses:', error);
         console.warn('❌ [CART-ATTRS] Error details:', error.message);
         console.warn('❌ [CART-ATTRS] Error stack:', error.stack);
       }
}

// Function to update cart attributes using Shopify Cart API
function updateCartAttributes(attributes) {
     console.log('🛒 [CART-API] Sending cart attributes update to Shopify...');
     console.log('🛒 [CART-API] Request payload size:', JSON.stringify({attributes}).length);
     console.log('🛒 [CART-API] Attributes being sent:', Object.keys(attributes));

    //  console.error("CAA: Update cart attributes:", Object.keys(attributes));
    //  try {
    //   newrelic.log('CAA NR: Update cart attributes:', {level: 'debug', customAttributes: { data: JSON.stringify(Object.keys(attributes)) }})
    //  } catch(e) {}
     
     const startTime = Date.now();
     
     fetch('/cart/update.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json',
       },
       body: JSON.stringify({
         attributes: attributes
       })
     })
     .then(response => {
      // console.error("CAA: Update cart attributes response:", response);
      // try {
      //   newrelic.log('CAA NR: Update cart attributes response:', {level: 'debug', customAttributes: { data: JSON.stringify(response) }})
      // } catch(e) {}

       const duration = Date.now() - startTime;
       console.log(`🛒 [CART-API] Response received in ${duration}ms`);
       console.log('🛒 [CART-API] Response status:', response.status);
       
       if (!response.ok) {
         throw new Error(`HTTP ${response.status}: ${response.statusText}`);
       }
       
       window.dispatchEvent(new Event('addressUpdated'));
       return response.json();
     })
     .then(data => {
      // console.error("CAA: Update cart attributes data:", data);
      // try {
      //   newrelic.log('CAA NR: Update cart attributes data:', {level: 'debug', customAttributes: { data: JSON.stringify(data) }})
      // } catch(e) {}
       console.log('✅ [CART-API] Cart attributes updated successfully!');
       console.log('✅ [CART-API] Updated cart data:', data);
       console.log('✅ [CART-API] Checkout extension should now have access to addresses');
     })
     .catch(error => {
      console.error("[CAA]: Update cart attributes error:", error);
      console.error(error);
      try {
        newrelic.log('[CAANR]: Update cart attributes error:', { errMessage: error?.message, errStack: error?.stack, kind: error?.name });
        // newrelic.noticeError(error, { errMessage: error?.message, errStack: error?.stack, kind: error?.name, context: 'CAA NR: Update cart attributes error notice' });
      } catch(e) {}
      //  console.error('❌ [CART-API] Failed to update cart attributes:', error);
      //  console.error('❌ [CART-API] Error details:', error.message);
     });
}

// Function to manually update cart attributes with current debug data (for testing)
function manualUpdateCartAttributes() {
     console.log('🛒 [DEBUG] Manual cart attributes update triggered');
     
     const debugData = localStorage.getItem('pilgrim_debug_customer_data');
     if (!debugData) {
       console.log('🛒 [DEBUG] No debug customer data found');
      //  alert('No customer data found in localStorage');
       return;
     }
     
     try {
       const parsedData = JSON.parse(debugData);
       if (parsedData.customer && parsedData.customer.addresses) {
         updateCartAttributesWithAddresses(parsedData.customer.addresses);
        //  alert('Cart attributes updated with current address data!');
       } else {
        //  alert('No addresses found in customer data');
       }
     } catch (error) {
      //  console.error('❌ [DEBUG] Error parsing debug data:', error);
      //  alert('Error parsing customer data');
     }
}

// Function to manually trigger cart data refresh (for testing)
function manualCartDataRefresh() {
    console.log('🛒 [DEBUG] Manual cart data refresh triggered');
    sessionStorage.removeItem('pilgrim_cart_data_refreshed_session');
    
    if (PilgrimAuth && PilgrimAuth.isLoggedIn()) {
      PilgrimAuth.getCustomerData()
        .then(response => {
          if (response && response.data && response.data.customer) {
            const debugData = {
              timestamp: new Date().toISOString(),
              customerId: PilgrimAuth.getCurrentCustomerId(),
              customer: response.data.customer,
              orders: response.data.orders
            };
            
            localStorage.setItem('pilgrim_debug_customer_data', JSON.stringify(debugData));
            sessionStorage.setItem('pilgrim_cart_data_refreshed_session', 'true');
             
            console.log('✅ [DEBUG] Manual cart data refresh completed');
             
            // Also update cart attributes with fresh address data
            if (response.data.customer.addresses) {
              updateCartAttributesWithAddresses(response.data.customer.addresses);
            }
             
            // alert('Customer data refreshed and cart attributes updated successfully!');
          }
        })
        .catch(error => {
          // console.error('❌ [DEBUG] Manual cart data refresh failed:', error);
          // alert('Failed to refresh customer data');
        });
    } else {
      // alert('User not logged in');
    }
}

// Function to reset cart refresh session (for testing)
function resetCartRefreshSession() {
     sessionStorage.removeItem('pilgrim_cart_data_refreshed_session');
     isCurrentlyRefreshing = false;
     lastRefreshAttempt = 0;
     sessionRefreshed = null;
     console.log('🛒 [DEBUG] Cart refresh session reset - ready for new refresh');
    //  alert('Cart refresh session reset successfully!');
}

// Function to force immediate cart refresh (for testing)
function forceCartRefresh() {
    console.log('🛒 [DEBUG] Force cart refresh triggered');
    sessionStorage.removeItem('pilgrim_cart_data_refreshed_session');
    
    if (PilgrimAuth && PilgrimAuth.isLoggedIn()) {
      // Reset flags
      isCurrentlyRefreshing = false;
      lastRefreshAttempt = 0;
      
      // Get fresh customer data and update cart
      PilgrimAuth.getCustomerData()
        .then(response => {
          if (response && response.data && response.data.customer) {
            const debugData = {
              timestamp: new Date().toISOString(),
              customerId: PilgrimAuth.getCurrentCustomerId(),
              customer: response.data.customer,
              orders: response.data.orders
            };
            
            localStorage.setItem('pilgrim_debug_customer_data', JSON.stringify(debugData));
            sessionStorage.setItem('pilgrim_cart_data_refreshed_session', 'true');
            
            console.log('✅ [DEBUG] Force cart refresh completed');
            
            // Update cart attributes with fresh address data
            if (response.data.customer.addresses) {
              updateCartAttributesWithAddresses(response.data.customer.addresses);
              // alert('Cart attributes updated immediately with fresh address data!');
            } else {
              // alert('No addresses found in customer data');
            }
          }
        })
        .catch(error => {
          // console.error('❌ [DEBUG] Force cart refresh failed:', error);
          // alert('Failed to refresh customer data: ' + error.message);
        });
    } else {
      // alert('User not logged in');
    }
}

// Expose functions globally for testing
window.manualCartDataRefresh = manualCartDataRefresh;
window.manualUpdateCartAttributes = manualUpdateCartAttributes;
window.resetCartRefreshSession = resetCartRefreshSession;
window.forceCartRefresh = forceCartRefresh;